import ajax from "./ajax";

export function requestCurrentUser() {
  return ajax("/current_user?enterprise=true");
}

export function getOrderApiKey() {
  return ajax("/current_user/api-key").then((res) => res.data);
}

export function rotateOrderApiKey() {
  return ajax("/current_user/api-key/rotate", { method: "POST" }).then(
    (res) => res.data
  );
}

export function getQuoteIntakeKey() {
  return ajax("/current_user/quote-intake-key").then((res) => res.data);
}

export function rotateQuoteIntakeKey() {
  return ajax("/current_user/quote-intake-key/rotate", { method: "POST" }).then(
    (res) => res.data
  );
}

export function getWebhookEndpoint() {
  return ajax("/current_user/webhook-endpoint").then((res) => res.data);
}

export function saveWebhookEndpoint(data) {
  return ajax("/current_user/webhook-endpoint", {
    method: "PUT",
    data,
  }).then((res) => res.data);
}

export function rotateWebhookSecret() {
  return ajax("/current_user/webhook-endpoint/rotate-secret", {
    method: "POST",
  }).then((res) => res.data);
}

export function testWebhookEndpoint() {
  return ajax("/current_user/webhook-endpoint/test", { method: "POST" }).then(
    (res) => res.data
  );
}

export function createUser(data) {
  return ajax("/current_user", { method: "POST", data });
}

export function signupUser(data) {
  return ajax("/auth/signup", { method: "POST", data });
}

/** Hostname-scoped login. Returns { customToken } for this printer. */
export function loginTenantUser(data) {
  return ajax("/auth/login", { method: "POST", data });
}

/**
 * Accounts made by a Shopify install have no password. The signed-in owner
 * can set one once; changing it later goes through Forgot password.
 */
export function setAccountPassword(password) {
  return ajax("/auth/account-password", {
    method: "POST",
    data: { password },
  });
}

/** "Not now" on the set-a-password prompt (snoozes it for 30 days). */
export function dismissAccountPasswordPrompt() {
  return ajax("/auth/account-password/dismiss", { method: "POST" });
}

/** Google → the account on this printer, not the first Firebase Google uid. */
export function loginGoogleTenant(data) {
  return ajax("/auth/google", { method: "POST", data });
}

/** Switch/create this hostname's account for the inbox already signed in. */
export function adoptPrinterSession() {
  return ajax("/auth/adopt-printer", { method: "POST" });
}

export function requestPasswordResetEmail(data) {
  return ajax("/auth/forgot-password", { method: "POST", data });
}

export function updateUser(data) {
  return ajax("/current_user", { method: "PUT", data });
}

export function deleteUser(userId) {
  return ajax(`/users/${userId}`, { method: "DELETE" });
}

export function inviteUser(data) {
  return ajax(`/users/invitation`, { method: "POST", data });
}

export function getInvitations() {
  return ajax(`/users/invitations`);
}

export function resendInvitation(invitationId) {
  return ajax(`/users/invitations/${invitationId}/resend`, { method: "POST" });
}

export function cancelInvitation(invitationId) {
  return ajax(`/users/invitations/${invitationId}/cancel`, { method: "POST" });
}

export function updateEnterpriseUser(id, data) {
  return ajax(`/users/enterprise-user/${id}`, { method: "PUT", data });
}

export function createSellerAccount(data) {
  return ajax(`/users/sellers`, { method: "POST", data });
}

/** Count of non-cancelled orders currently on hold for a seller. */
export function getHeldOrderCount(id) {
  return ajax(`/users/enterprise-user/${id}/held-order-count`);
}

/**
 * Switch the signed-in user's active warehouse location.
 * Pass null / "" for HQ "All locations" (unscoped).
 */
export function switchActiveLocation(locationId) {
  return ajax(`/users/active-location`, {
    method: "PUT",
    data: {
      locationId:
        locationId === null || locationId === undefined || locationId === ""
          ? null
          : locationId,
    },
  });
}

export function getEmployeeActivity(query = {}) {
  return ajax(`/users/employee-activity`, { query });
}

export function getEmployeeActivitySummary(query = {}) {
  return ajax(`/users/employee-activity/summary`, { query });
}

/** Printer apps: resolve which employee entered a shop-floor PIN. */
export function identifyUserByStaffPin(pin) {
  return ajax(`/users/identify-by-pin`, {
    method: "POST",
    data: { pin },
  });
}

/** PIN on the shared gun. Returns a custom token for that employee. */
export function sessionByStaffPin(pin, { skipAuth = false, enterpriseId } = {}) {
  return ajax(`/users/session-by-pin`, {
    method: "POST",
    data: {
      pin,
      ...(enterpriseId ? { enterpriseId } : {}),
    },
    skipAuth,
  });
}
